__turbopack_context__.v({
  "actionBtn": "EditableText-module__gscPhG__actionBtn",
  "actions": "EditableText-module__gscPhG__actions",
  "alignCenter": "EditableText-module__gscPhG__alignCenter",
  "alwaysShowEdit": "EditableText-module__gscPhG__alwaysShowEdit",
  "cancelBtn": "EditableText-module__gscPhG__cancelBtn",
  "counter": "EditableText-module__gscPhG__counter",
  "displayRow": "EditableText-module__gscPhG__displayRow",
  "displayRowClickable": "EditableText-module__gscPhG__displayRowClickable",
  "editBtn": "EditableText-module__gscPhG__editBtn",
  "editContainer": "EditableText-module__gscPhG__editContainer",
  "editContainerMultiline": "EditableText-module__gscPhG__editContainerMultiline",
  "editFooter": "EditableText-module__gscPhG__editFooter",
  "input": "EditableText-module__gscPhG__input",
  "placeholder": "EditableText-module__gscPhG__placeholder",
  "root": "EditableText-module__gscPhG__root",
  "rootFitContent": "EditableText-module__gscPhG__rootFitContent",
  "saveBtn": "EditableText-module__gscPhG__saveBtn",
  "text": "EditableText-module__gscPhG__text",
  "textFitContent": "EditableText-module__gscPhG__textFitContent",
  "textarea": "EditableText-module__gscPhG__textarea",
});
